module.exports = __webpack_public_path__ + "img/cashback.1e5b478d.svg";